import { render, staticRenderFns } from "./CardSingleCompanyName.vue?vue&type=template&id=54fb915c&scoped=true"
import script from "./CardSingleCompanyName.vue?vue&type=script&lang=js"
export * from "./CardSingleCompanyName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fb915c",
  null
  
)

export default component.exports